<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline" v-if="!queryParam.id">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="名称">
              <a-input v-model="queryParam.name" placeholder="请输入名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="2" :xs="6">
            <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
          </a-col>
          <a-col :md="2" :xs="6">
            <a-button type="primary" icon="plus" @click="handleAdd">新建</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :pageNum="pageNum"
      :data="loadData"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a-popconfirm
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多 <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleChangeDepartment(record)">部门</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleChangeCategory(record)">分类</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      :visible="visible"
      v-if="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <change-department-form
      ref="changeDepartmentModal"
      :visible="changeDepartmentVisible"
      v-if="changeDepartmentVisible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleChangeDepartmentCancel"
      @ok="handleChangeDepartmentOk"
    />
    <change-category-form
      ref="changeCategoryModal"
      :visible="changeCategoryVisible"
      v-if="changeCategoryVisible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleChangeCategoryCancel"
      @ok="handleChangeCategoryOk"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import CreateForm from '../modules/CreateForm'
import ChangeDepartmentForm from '../modules/ChangeDepartmentForm'
import ChangeCategoryForm from '../modules/ChangeCategoryForm'

import { oaRoleCreate, oaRoleDelete, oaRoleList, oaRoleUpdate } from '@/api/oa_role'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm,
    ChangeDepartmentForm,
    ChangeCategoryForm
  },
  data () {
    return {
      pageNum: 1,
      loading: false,
      confirmLoading: false,
      // 创建窗口控制
      visible: false,
      mdl: {},
      // 高级搜索 展开/关闭
      changeDepartmentVisible: false,
      changeCategoryVisible: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          fixed: 'left',
          title: '序号',
          width: 50,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '名称',
          dataIndex: 'name',
          width: 150,
          ellipsis: true
        },
        {
          title: '部门',
          dataIndex: 'department.name',
          width: 200,
          ellipsis: true
        },
        {
          title: '分类',
          dataIndex: 'category.name',
          width: 200,
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 180,
          scopedSlots: { customRender: 'action' }
        }

      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return oaRoleList(Object.assign(parameter, this.queryParam))
          .then(({ data }) => {
            return data
          })
      }
    }
  },
  created () {
    this.setCurrentPage()
  },
  methods: {
    setCurrentPage () {
      const page = this.$store.getters.pop
      if (page) {
        console.log(page)
        const current = page.split('#$$#')[0]
        const query = page.split('#$$#')[1]
        const path = page.split('#$$#')[2]
        sessionStorage.removeItem('CurrentPage')
        if (path === this.$route.path) {
          if (!isNaN(Number(current))) {
            this.pageNum = Number(current)
          }
          if (query) {
            this.queryParam = JSON.parse(query)
          }
        } else {
          this.queryParam = {}
          this.$store.dispatch('clear')
        }
      }
    },
    handleAdd () {
      this.mdl = null
      this.visible = true
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleChangeDepartmentCancel () {
      this.changeDepartmentVisible = false
      const form = this.$refs.changeDepartmentModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleChangeCategoryCancel () {
      this.changeCategoryVisible = false
      const form = this.$refs.changeCategoryModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleEdit (record) {
      this.$emit('onEdit', record)
    },
    handleChangeDepartment (record) {
      this.mdl = record
      this.changeDepartmentVisible = true
    },
    handleChangeCategory (record) {
      this.mdl = record
      this.changeCategoryVisible = true
    },
    handleDetail (record) {
      // sessionStorage.setItem('CurrentPage', this.$refs.table.getCurrent() + '#$$#' + JSON.stringify(this.queryParam) + '#$$#' + this.$route.path)
      this.$store.dispatch('push', this.$refs.table.getCurrent() + '#$$#' + JSON.stringify(this.queryParam) + '#$$#' + this.$route.path)
      this.$router.push({ path: '/electricity_meter_record/' + record.id })
    },
    handleDelete (record) {
      oaRoleDelete(record.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleOk () {
      const form = this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          oaRoleCreate(values).then(res => {
              this.visible = false
              this.confirmLoading = false
            // 重置表单数据
            form.resetFields()
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    handleChangeDepartmentOk () {
      const form = this.$refs.changeDepartmentModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          // 新增
          oaRoleUpdate(values, this.mdl.id).then(res => {
              this.changeDepartmentVisible = false
              this.confirmLoading = false
            // 重置表单数据
            if (res.code === 1000) {
              form.resetFields()
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    handleChangeCategoryOk () {
      const form = this.$refs.changeCategoryModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          // 新增
          oaRoleUpdate(values, this.mdl.id).then(res => {
              this.changeCategoryVisible = false
              this.confirmLoading = false
            // 重置表单数据
            if (res.code === 1000) {
              form.resetFields()
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>
